import { render, staticRenderFns } from "./assignmentSolutionlist.html?vue&type=template&id=4020fd61&scoped=true&"
import script from "./assignmentSolutionlist.js?vue&type=script&lang=js&"
export * from "./assignmentSolutionlist.js?vue&type=script&lang=js&"
import style0 from "./assignmentSolutionlist.css?vue&type=style&index=0&id=4020fd61&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4020fd61",
  null
  
)

export default component.exports